import { Component, OnInit, OnDestroy, ViewContainerRef, } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { PoService } from '../po.service';
import { Subscription } from 'rxjs/Subscription';
import { PoOrder } from '../po-orders';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import {Utils} from '../../../../shared/utils';

@Component({
  selector: 'app-po-orders-list',
  templateUrl: './po-orders-list.component.html',
  styleUrls: ['./po-orders-list.component.scss']
})
export class PoOrdersListComponent implements OnInit, OnDestroy {
  data: PoOrder[];
  subscription: Subscription = new Subscription();
  totalPriceValue: number = 0;
  totalMetersValue: number = 0;
  summaryTotalPrices: number = 0;
  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  pageSize: number = 5;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'qty', label: 'QTY (Meters)' },
    { name: 'price', label: 'Unit Price (CAD)' }
  ];

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _poService: PoService,
    private _viewContainerRef: ViewContainerRef,
    public _authService: AuthenticationService
) {}

  ngOnInit(): void {
    /*
    this.subscription = this._poService
    .getPoItems()
    .subscribe((poOrders: PoOrder[]) => {
      this.data = poOrders;
      this.filteredData = this.data;
      this.filteredTotal = this.data.length;
      this.selectedRows = this.filteredData;
      this.filter();
      this.totalPriceValue = this.data.reduce((acc: number, el: PoOrder) => acc + +el.price, 0);
      this.totalMetersValue = this.data.reduce((acc, el) => acc + +el.qty, 0);
      this.summaryTotalPrices = this.data.reduce((acc, el) => acc + +(el.qty * el.price), 0);

    });*/
  }

  calculateTotalRowPrice(row: PoOrder): number {
    return row.unit_price * row.quantity;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this.pageSize = pagingEvent.pageSize;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
    .filter((column: ITdDataTableColumn) => {
      return ((column.filter === undefined && column.hidden === true) ||
              (column.filter !== undefined && column.filter === false));
    }).map((column: ITdDataTableColumn) => {
      return column.name;
    });
    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this.pageSize);
    this.filteredData = newData;
  }

  openConfirm(): void {
    this._dialogService.openConfirm({
      message: 'Are you sure that you want to delete this item?',
      disableClose: false,
      title: 'Confirm',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        // DO SOMETHING
      } else {
        // DO SOMETHING ELSE
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/pos/po-orders-list/po-orders-list.component.ts